import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, FormsModule } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ECalendarValue, IDatePickerConfig, DpDatePickerModule } from 'ng2-date-picker';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        DpDatePickerModule,
        FormsModule,
    ],
})
export class TimePickerComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder) {

    }


    //service item data
    @Input() product;

    availableFrom: moment.Moment;

    availableTo: moment.Moment;

    @Input() selected = moment();

    @Input() time = this.fb.control('');

    onSelect(data) {
        let selectedTime: moment.Moment;
        try {
            selectedTime = data?.date;

        } catch (error) {

            console.log('Error in time picker output')
        }
        this.time.setValue(moment(selectedTime.format("hh:mm:ss a")));
    }

    log(data) {
        var selectedTime: moment.Moment;
        try {
            selectedTime = data?.date;
            this.time.setValue(selectedTime);
        } catch (error) {

            console.log('Error in time picker output')
        }


    }



    config: IDatePickerConfig;
    initTime = () => {

        try {
            if (this.product?.time[0]?.start && this.product?.time[0]?.end) {

                this.availableFrom = moment(this.product?.time[0]?.start, 'HH:mm:ss').isValid() ? moment(this.product?.time[0]?.start, 'HH:mm:ss') : moment();
                this.availableTo = moment(this.product?.time[0]?.end, 'HH:mm:ss').isValid() ? moment(this.product?.time[0]?.end, 'HH:mm:ss') : moment();
                this.config = {
                    ...this.DEF_CONF,
                }

            }



        } catch (error) {
            console.log(
                'Error initing Time Picker: ' + error?.toString()
            );
        }
    };

    ngOnInit(): void {
        this.initTime();
    }

    DEF_CONF: IDatePickerConfig = {
        firstDayOfWeek: 'su',
        monthFormat: 'MMM, YYYY',
        disableKeypress: false,
        allowMultiSelect: true,
        closeOnSelect: undefined,
        closeOnSelectDelay: 100,
        openOnFocus: true,
        openOnClick: true,
        onOpenDelay: 0,
        closeOnEnter: true,
        weekDayFormat: 'ddd',
        showNearMonthDays: true,
        showWeekNumbers: false,
        enableMonthSelector: true,
        yearFormat: 'YYYY',
        showGoToCurrent: true,
        dayBtnFormat: 'DD',
        monthBtnFormat: 'MMM',
        hours12Format: 'hh',
        hours24Format: 'HH',
        meridiemFormat: 'A',
        minutesFormat: 'mm',
        minutesInterval: 1,
        secondsFormat: 'ss',
        secondsInterval: 1,
        showSeconds: false,
        showTwentyFourHours: false,
        timeSeparator: ':',
        multipleYearsNavigateBy: 10,
        showMultipleYearsNavigation: false,
        hideInputContainer: false,
        returnedValueType: ECalendarValue.String,
        unSelectOnClick: true,
        hideOnOutsideClick: true,
        numOfMonthRows: 3
    };

}
